import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";

const voices = [
  {
    quote:
      "以前刷到一条爆料只能跟着评论区走，现在会先来这边看时间线，至少知道矛盾出现在哪一步。",
    name: "陈默",
    role: "内容爱好者",
  },
  {
    quote:
      "截图对比那一段讲得很清楚，尤其是字体基线和缩放痕迹的判断，做内容时会直接引用。",
    name: "林知夏",
    role: "自媒体编辑",
  },
  {
    quote:
      "最难得的是不确定的地方会直接写「存疑」和「依据不足」，而不是硬给一个结论。",
    name: "周予安",
    role: "信息核查志愿者",
  },
];

export default function BrandSection() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <SectionHeading
            eyebrow="关于蝌蚪爆料"
            title="不做裁判，只把依据摆清楚"
            description="我们认为多数争议并不是没有信息，而是信息被拆散了。这个站点做的事，是把散落的片段重新拼回时间线上。"
          />
          <div className="mt-6 space-y-4">
            {[
              "只呈现公开可查的原始依据，并标注来源类型。",
              "对无法验证的部分明确写「存疑」，不预设立场。",
              "事件状态随新依据更新，修改记录留在时间线中。",
            ].map((point) => (
              <p key={point} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-700">
                <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" />
                {point}
              </p>
            ))}
          </div>
          <Link
            to="/about"
            className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-3 font-label text-sm text-background-50 transition-colors hover:bg-foreground-800 cursor-pointer"
          >
            了解本站定位 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {voices.map((v) => (
              <figure
                key={v.name}
                className="flex h-full flex-col justify-between rounded-lg border border-background-300 bg-background-100 p-5"
              >
                <i className="ri-double-quotes-l text-2xl text-primary-400" />
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  {v.quote}
                </blockquote>
                <figcaption className="mt-4 border-t border-background-200 pt-3">
                  <p className="font-heading text-sm font-semibold text-foreground-900">{v.name}</p>
                  <p className="font-label text-xs text-foreground-500">{v.role}</p>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}